var _path, _path2, _g, _g2, _g3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _g4, _path3, _path4, _path5, _path6, _g5, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagicWand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64062 29.4229C4.08873 29.9775 3.19143 29.9785 2.6382 29.4253C2.08686 28.874 2.08578 27.9804 2.63578 27.4277L19.9219 10.0576C20.4738 9.50302 21.3711 9.50193 21.9243 10.0552C22.4756 10.6065 22.4767 11.5001 21.9267 12.0527L4.64062 29.4229Z",
    fill: "url(#paint0_linear_715_15484)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64062 29.4229C4.08873 29.9775 3.19143 29.9785 2.6382 29.4253C2.08686 28.874 2.08578 27.9804 2.63578 27.4277L19.9219 10.0576C20.4738 9.50302 21.3711 9.50193 21.9243 10.0552C22.4756 10.6065 22.4767 11.5001 21.9267 12.0527L4.64062 29.4229Z",
    fill: "url(#paint1_linear_715_15484)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_715_15484)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5201 7.73946C25.4466 7.37049 25.1534 7.08233 24.7895 6.98692C24.3806 6.87969 23.9387 6.71365 23.4415 6.47209C23.0299 6.27207 23.0299 5.70251 23.4415 5.50249C23.9387 5.26093 24.3806 5.09489 24.7895 4.98766C25.1534 4.89224 25.4466 4.60409 25.5201 4.23512C25.6312 3.67756 25.8133 2.99032 26.089 2.3176C26.2626 1.89413 26.8138 1.89413 26.9874 2.3176C27.2631 2.99032 27.4452 3.67757 27.5563 4.23512C27.6298 4.60409 27.923 4.89217 28.2868 4.98794C28.6939 5.09511 29.133 5.26092 29.6279 5.50199C30.0394 5.7024 30.0394 6.27218 29.6279 6.47259C29.133 6.71366 28.6939 6.87947 28.2868 6.98664C27.923 7.08241 27.6298 7.37049 27.5563 7.73946C27.4452 8.29701 27.2631 8.98426 26.9874 9.65698C26.8138 10.0804 26.2626 10.0804 26.089 9.65698C25.8133 8.98426 25.6312 8.29701 25.5201 7.73946Z",
    fill: "url(#paint2_linear_715_15484)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_715_15484)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2609 7.29702C14.206 7.02124 13.9869 6.80586 13.7149 6.73454C13.4092 6.65439 13.0789 6.53028 12.7073 6.34973C12.3996 6.20023 12.3996 5.77451 12.7073 5.62501C13.0789 5.44445 13.4092 5.32034 13.7149 5.2402C13.9869 5.16888 14.206 4.9535 14.2609 4.67771C14.344 4.26097 14.4801 3.74729 14.6862 3.24447C14.8159 2.92795 15.2279 2.92795 15.3576 3.24447C15.5637 3.74729 15.6998 4.26097 15.7829 4.67771C15.8378 4.9535 16.0569 5.16882 16.3289 5.24041C16.6332 5.32051 16.9614 5.44444 17.3313 5.62463C17.6388 5.77443 17.6388 6.2003 17.3313 6.3501C16.9614 6.53029 16.6332 6.65423 16.3289 6.73433C16.0569 6.80591 15.8378 7.02124 15.7829 7.29702C15.6998 7.71376 15.5637 8.22744 15.3576 8.73026C15.2279 9.04678 14.8159 9.04678 14.6862 8.73026C14.4801 8.22744 14.344 7.71376 14.2609 7.29702Z",
    fill: "url(#paint3_linear_715_15484)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_715_15484)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8234 18.2658C23.7685 17.99 23.5494 17.7746 23.2774 17.7033C22.9717 17.6231 22.6414 17.499 22.2698 17.3185C21.9621 17.169 21.9621 16.7433 22.2698 16.5938C22.6414 16.4132 22.9717 16.2891 23.2774 16.2089C23.5494 16.1376 23.7685 15.9222 23.8234 15.6465C23.9065 15.2297 24.0426 14.716 24.2487 14.2132C24.3784 13.8967 24.7904 13.8967 24.9201 14.2132C25.1262 14.716 25.2623 15.2297 25.3454 15.6465C25.4003 15.9222 25.6194 16.1376 25.8914 16.2092C26.1957 16.2893 26.5239 16.4132 26.8938 16.5934C27.2013 16.7432 27.2013 17.1691 26.8938 17.3189C26.5239 17.499 26.1957 17.623 25.8914 17.7031C25.6194 17.7747 25.4003 17.99 25.3454 18.2658C25.2623 18.6825 25.1262 19.1962 24.9201 19.699C24.7904 20.0155 24.3784 20.0155 24.2487 19.699C24.0426 19.1962 23.9065 18.6825 23.8234 18.2658Z",
    fill: "url(#paint4_linear_715_15484)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.7578,
    cy: 12.9512,
    r: 1.24219,
    fill: "url(#paint5_radial_715_15484)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.7578,
    cy: 12.9512,
    r: 1.24219,
    fill: "url(#paint6_radial_715_15484)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0234,
    cy: 21.123,
    r: 1.24219,
    fill: "url(#paint7_radial_715_15484)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0234,
    cy: 21.123,
    r: 1.24219,
    fill: "url(#paint8_radial_715_15484)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0527,
    cy: 13.1621,
    r: 1.19336,
    fill: "url(#paint9_radial_715_15484)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0527,
    cy: 13.1621,
    r: 1.19336,
    fill: "url(#paint10_radial_715_15484)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.043,
    cy: 3.00708,
    r: 0.996094,
    fill: "url(#paint11_radial_715_15484)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.043,
    cy: 3.00708,
    r: 0.996094,
    fill: "url(#paint12_radial_715_15484)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_715_15484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3281 12.2402L4.17188 27.459",
    stroke: "url(#paint13_linear_715_15484)",
    strokeWidth: 0.5
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1992 11.7886L19.922 10.0575C20.4739 9.50294 21.3712 9.50185 21.9244 10.0551C22.4757 10.6064 22.4768 11.5 21.9268 12.0526L20.2127 13.7751L18.1992 11.7886Z",
    fill: "#CFC9D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1992 11.7886L19.922 10.0575C20.4739 9.50294 21.3712 9.50185 21.9244 10.0551C22.4757 10.6064 22.4768 11.5 21.9268 12.0526L20.2127 13.7751L18.1992 11.7886Z",
    fill: "url(#paint14_linear_715_15484)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1992 11.7886L19.922 10.0575C20.4739 9.50294 21.3712 9.50185 21.9244 10.0551C22.4757 10.6064 22.4768 11.5 21.9268 12.0526L20.2127 13.7751L18.1992 11.7886Z",
    fill: "url(#paint15_linear_715_15484)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1992 11.7886L19.922 10.0575C20.4739 9.50294 21.3712 9.50185 21.9244 10.0551C22.4757 10.6064 22.4768 11.5 21.9268 12.0526L20.2127 13.7751L18.1992 11.7886Z",
    fill: "url(#paint16_radial_715_15484)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_715_15484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.63882 29.4252C3.19205 29.9784 4.08935 29.9773 4.64124 29.4228L6.33071 27.7251L4.32486 25.731L2.6364 27.4276C2.0864 27.9803 2.08749 28.8739 2.63882 29.4252Z",
    fill: "#CFC6DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.63882 29.4252C3.19205 29.9784 4.08935 29.9773 4.64124 29.4228L6.33071 27.7251L4.32486 25.731L2.6364 27.4276C2.0864 27.9803 2.08749 28.8739 2.63882 29.4252Z",
    fill: "url(#paint17_linear_715_15484)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63882 29.4252C3.19205 29.9784 4.08935 29.9773 4.64124 29.4228L6.33071 27.7251L4.32486 25.731L2.6364 27.4276C2.0864 27.9803 2.08749 28.8739 2.63882 29.4252Z",
    fill: "url(#paint18_linear_715_15484)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63882 29.4252C3.19205 29.9784 4.08935 29.9773 4.64124 29.4228L6.33071 27.7251L4.32486 25.731L2.6364 27.4276C2.0864 27.9803 2.08749 28.8739 2.63882 29.4252Z",
    fill: "url(#paint19_radial_715_15484)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_715_15484",
    x: 22.9828,
    y: 1.85,
    width: 7.10273,
    height: 8.27461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.513726 0 0 0 0 0.392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15484"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.823529 0 0 0 0 0.407843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_715_15484",
    result: "effect2_innerShadow_715_15484"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_715_15484",
    x: 12.3266,
    y: 2.85708,
    width: 5.38594,
    height: 6.26069,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.513726 0 0 0 0 0.392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15484"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.823529 0 0 0 0 0.407843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_715_15484",
    result: "effect2_innerShadow_715_15484"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_715_15484",
    x: 21.8891,
    y: 13.8258,
    width: 5.38594,
    height: 6.26069,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.513726 0 0 0 0 0.392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15484"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.823529 0 0 0 0 0.407843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_715_15484",
    result: "effect2_innerShadow_715_15484"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_715_15484",
    x: 3.49414,
    y: 11.5637,
    width: 16.5117,
    height: 16.5718,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_15484"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_715_15484",
    x: 2.12461,
    y: 25.231,
    width: 4.20547,
    height: 4.6084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.698039 0 0 0 0 0.619608 0 0 0 0 0.792157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_15484",
    x1: 19.2344,
    y1: 13.0215,
    x2: 5.17188,
    y2: 27.3965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60105F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54155E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_715_15484",
    x1: 5.5,
    y1: 24.0684,
    x2: 6.96875,
    y2: 25.5215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#523253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#523253",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_715_15484",
    x1: 28.9803,
    y1: 4.11173,
    x2: 25.016,
    y2: 8.07946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_715_15484",
    x1: 16.8472,
    y1: 4.58548,
    x2: 13.8841,
    y2: 7.55115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAF36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_715_15484",
    x1: 26.4097,
    y1: 15.5542,
    x2: 23.4466,
    y2: 18.5199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAF36"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_715_15484",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.3083 12.4626) rotate(127.823) scale(1.87474 1.75343)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E68F2B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_715_15484",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.7578 12.1313) rotate(90) scale(2.06202 1.79752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E37A42",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E37A42"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_715_15484",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5739 20.6345) rotate(127.823) scale(1.87474 1.75343)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E68F2B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_715_15484",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.0234 20.3032) rotate(90) scale(2.06202 1.79752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E37A42",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E37A42"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_715_15484",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.5816 12.6927) rotate(127.823) scale(1.80105 1.68451)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E68F2B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_715_15484",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.0527 12.3745) rotate(90) scale(1.98096 1.72686)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E37A42",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E37A42"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_715_15484",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4844 2.6153) rotate(127.823) scale(1.50333 1.40606)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E68F2B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_715_15484",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.043 2.34967) rotate(90) scale(1.6535 1.44141)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.869366,
    stopColor: "#E37A42",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E37A42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_715_15484",
    x1: 18.5469,
    y1: 13.334,
    x2: 4.17188,
    y2: 27.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#692167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B2460"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_715_15484",
    x1: 18.8473,
    y1: 11.0208,
    x2: 19.8496,
    y2: 11.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1BFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1BFC3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_715_15484",
    x1: 21.422,
    y1: 12.8808,
    x2: 20.797,
    y2: 12.2245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A1BF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_715_15484",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.797 10.1152) rotate(133.939) scale(1.19345 1.44186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.209653,
    stopColor: "#ECE8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECE8F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_715_15484",
    x1: 3.28382,
    y1: 26.5848,
    x2: 4.27766,
    y2: 27.5781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A6AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A6AD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_715_15484",
    x1: 2.60999,
    y1: 29.7401,
    x2: 3.39124,
    y2: 28.7714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#968FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#968FA1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_715_15484",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.27766 25.8964) rotate(98.4726) scale(4.8498 4.95098)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.661224,
    stopColor: "#8F6EAF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918366,
    stopColor: "#8F6EAF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWand);
export default __webpack_public_path__ + "static/media/MagicWand.fa038abdd216e3e420ba644133b72997.svg";
export { ForwardRef as ReactComponent };